import UniformMgmtRouter from './routes';

const UniformManagement = () => {
  return <UniformMgmtRouter />;
};

export default UniformManagement;
